// extracted by mini-css-extract-plugin
export default {"container":"Income_container__bB8H3","infoTopic":"Income_infoTopic__PLe6j","infoSubTopic":"Income_infoSubTopic__UcFWt","formContainer":"Income_formContainer__cy-b2"};